import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const BlacklistPage = ({ panelId }) => {
    // İzleyici rolü yalnızca görüntüleme yapar.
    const isViewer = (JSON.parse(localStorage.getItem('user') || '{}').role) === 'izleyici';
    const [blacklist, setBlacklist] = useState([]);
    const [blockedId, setBlockedId] = useState('');

    const fetchBlacklist = useCallback(async () => {
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || currentUser?.panelId;
            const res = await api.getBlacklist({ panelId: activePanelId || '' });
            setBlacklist(res.data);
        } catch (err) {
            console.error(err);
        }
    }, [panelId]);

    useEffect(() => {
        document.title = 'PayzoPay - Kara Liste';
        fetchBlacklist();
        const interval = setInterval(fetchBlacklist, 5000);
        return () => clearInterval(interval);
    }, [fetchBlacklist]);

    const logAction = async (action, details) => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || user?.panelId;
            const username = user ? user.username : 'Bilinmiyor';
            await api.createLog({ username, action, details, panelId: activePanelId });
        } catch (error) {
            console.error('Loglama hatası:', error);
        }
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const activePanelId = panelId || currentUser?.panelId;
            await api.addToBlacklist({ blockedId, panelId: activePanelId });
            logAction('Blacklist Ekleme', `${blockedId} engellendi.`);
            setBlockedId('');
            fetchBlacklist();
            alert('ID kara listeye eklendi.');
        } catch (error) {
            alert('Ekleme başarısız. Bu ID zaten listede olabilir.');
        }
    };

    const handleRemove = async (id) => {
        if (window.confirm('Yasağı kaldırmak istediğinize emin misiniz?')) {
            try {
                await api.removeFromBlacklist(id);
                logAction('Blacklist Kaldırma', `ID: ${id} yasağı kaldırıldı.`);
                fetchBlacklist();
            } catch (error) {
                alert('Silme başarısız.');
            }
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2 style={{ color: '#fff' }}>Kara Liste (Black List)</h2>
            {!isViewer && (
            <div className="card" style={{ background: 'var(--card-bg)', padding: '20px', marginBottom: '20px', color: 'var(--text-color)' }}>
                <form onSubmit={handleAdd} style={{ display: 'flex', gap: '10px' }}>
                    <input
                        type="text"
                        placeholder="Engellenecek ID (Örn: user123)"
                        value={blockedId}
                        onChange={(e) => setBlockedId(e.target.value)}
                        required
                        style={{ padding: '10px', flex: 1, border: '1px solid var(--input-border)', borderRadius: '4px', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)' }}
                    />
                    <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        Banla
                    </button>
                </form>
            </div>
            )}

            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '15px', boxShadow: 'var(--shadow)', overflow: 'hidden', padding: '20px' }}>
                <table cellPadding="15" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px', color: 'var(--text-color)' }}>
                    <thead>
                        <tr style={{ backgroundColor: 'var(--table-header-bg)', borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                            <th>Engellenen ID</th>
                            <th>Tarih</th>
                            <th>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {blacklist.map(item => {
                            const rowBg = 'var(--table-row-even)';
                            const radius = '15px';
                            return (
                                <tr key={item._id}>
                                    <td style={{ backgroundColor: rowBg, borderTopLeftRadius: radius, borderBottomLeftRadius: radius }}>{item.blockedId}</td>
                                    <td style={{ backgroundColor: rowBg }}>{new Date(item.createdAt).toLocaleString()}</td>
                                    <td style={{ backgroundColor: rowBg, borderTopRightRadius: radius, borderBottomRightRadius: radius }}>
                                        {!isViewer && (
                                        <button onClick={() => handleRemove(item._id)} style={{ padding: '5px 10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                            Banı Kaldır
                                        </button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BlacklistPage;